import React from 'react';

const DecorativeElements = () => {
  return (
    <div className="absolute inset-0 opacity-10 pointer-events-none">
      {/* Floating decorative elements */}
      <div className="absolute top-10 left-10 w-32 h-32 rounded-full blur-3xl bg-amber-400"></div>
      <div className="absolute bottom-20 right-20 w-40 h-40 rounded-full blur-3xl bg-amber-500"></div>
      <div className="absolute top-1/3 right-1/4 w-24 h-24 rounded-full blur-2xl bg-white"></div>
      <div className="absolute bottom-1/3 left-1/4 w-28 h-28 rounded-full blur-2xl bg-amber-300"></div>
      
      {/* Additional subtle elements */}
      <div className="absolute top-20 right-1/3 w-20 h-20 rounded-full blur-xl bg-white/50"></div>
      <div className="absolute bottom-40 left-1/3 w-16 h-16 rounded-full blur-xl bg-amber-400/50"></div>
    </div>
  );
};

export default DecorativeElements;
